module.exports = __webpack_public_path__ + "img/img_4657.0780f44e.jpg";